<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="2" class="text-right text-white font-weight-bold">LESS THAN<br/>1 YEAR</td>
                            <td class="text-right text-white font-weight-bold">BETWEEN 1<br/>AND 2 YEARS</td>
                            <td class="text-right text-white font-weight-bold">BETWEEN 2<br/>AND 5 YEARS</td>
                            <td class="text-right text-white font-weight-bold">OVER 5 YEARS</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td colspan="2" class="text-center text-white font-weight-bold">KD ’000</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="5">At 31 December 2020</td>
                        </tr>
                        <tr>
                            <td>Bank borrowings</td>
                            <td class="text-right">203,376</td>
                            <td class="text-right">513,306</td>
                            <td class="text-right">662,054</td>
                            <td class="text-right">2,050</td>
                        </tr>
                        <tr>
                            <td>Trade and other payables</td>
                            <td class="text-right">855,174</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td colspan="5">Other non-current liabilities</td>
                        </tr>
                        <tr>
                            <td>Payable to Ministry of Finance – Saudi Arabia</td>
                            <td class="text-right">58,492</td>
                            <td class="text-right">55,450</td>
                            <td class="text-right">153,199</td>
                            <td class="text-right">122,642</td>
                        </tr>
                        <tr>
                            <td> Due to CITC for acquisition of spectrum</td>
                            <td class="text-right">11,394</td>
                            <td class="text-right">30,562</td>
                            <td class="text-right">30,562</td>
                            <td class="text-right">94,309</td>
                        </tr>
                        <tr>
                            <td>Other</td>
                            <td class="text-right">2,515</td>
                            <td class="text-right">2,244</td>
                            <td class="text-right">3,411</td>
                            <td class="text-right">14,679</td>
                        </tr>
                        <tr>
                            <td>Lease liabilities</td>
                            <td class="text-right">49,673</td>
                            <td class="text-right">52,765</td>
                            <td class="text-right">61,752</td>
                            <td class="text-right">58,704</td>
                        </tr>
                        <tr>
                            <td>Net settled derivative liabilities - Interest rate swaps</td>
                            <td class="text-right">4,588</td>
                            <td class="text-right">5,184</td>
                            <td class="text-right">6,911</td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td class="blueColor" colspan="5">At 31 December 2019</td>
                        </tr>
                        <tr>
                            <td>Bank borrowings</td>
                            <td class="text-right">282,530</td>
                            <td class="text-right">219,772</td>
                            <td class="text-right">1,150,672</td>
                            <td class="text-right">22,855</td>
                        </tr>
                        <tr>
                            <td>Trade and other payables </td>
                            <td class="text-right">805,883</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td colspan="5">Other non-current liabilities</td>
                        </tr>
                        <tr>
                            <td>Payable to Ministry of Finance – Saudi Arabia</td>
                            <td class="text-right">12,452</td>
                            <td class="text-right">77,188</td>
                            <td class="text-right">214,862</td>
                            <td class="text-right">31,953</td>
                        </tr>
                        <tr>
                            <td>Due to CITC for acquisition of spectrum</td>
                            <td class="text-right">9,637</td>
                            <td class="text-right">9,637</td>
                            <td class="text-right">28,912</td>
                            <td class="text-right">53,188</td>
                        </tr>
                        <tr>
                            <td>Other</td>
                            <td class="text-right">-</td>
                            <td class="text-right">4,312</td>
                            <td class="text-right">4,489</td>
                            <td class="text-right">16,239</td>
                        </tr>
                        <tr>
                            <td>Lease liabilities</td>
                            <td class="text-right">61,976</td>
                            <td class="text-right">66,185</td>
                            <td class="text-right">74,792</td>
                            <td class="text-right">75,694</td>
                        </tr>
                        <tr>
                            <td>Net settled derivative liabilities - Interest rate swaps</td>
                            <td class="text-right">21,887</td>
                            <td class="text-right">19,218</td>
                            <td class="text-right">22,220</td>
                            <td class="text-right">-</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="2" class="text-right text-white font-weight-bold">أقل من سنة</td>
                            <td class="text-right text-white font-weight-bold">بين سنة<br/>وسنتين</td>
                            <td class="text-right text-white font-weight-bold">بين 2 و 5 سنوات</td>
                            <td class="text-right text-white font-weight-bold">أكثر من 5 سنوات</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td colspan="2" class="text-center text-white font-weight-bold">ألف دينار كويتي</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="5">كما في 31 ديسمبر 2020</td>
                        </tr>
                        <tr>
                            <td>قروض بنكية</td>
                            <td class="text-right">203,376</td>
                            <td class="text-right">513,306</td>
                            <td class="text-right">662,054</td>
                            <td class="text-right">2,050</td>
                        </tr>
                        <tr>
                            <td>ذمم تجارية دائنة وأخرى</td>
                            <td class="text-right">855,174</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td colspan="5">مطلوبات غير متداولة أخرى</td>
                        </tr>
                        <tr>
                            <td>مستحق لوزارة المالية السعودية</td>
                            <td class="text-right">58,492</td>
                            <td class="text-right">55,450</td>
                            <td class="text-right">153,199</td>
                            <td class="text-right">122,642</td>
                        </tr>
                        <tr>
                            <td>مستحق لهيئة الاتصالات وتقنية المعلومات مقابل طيف ترددي</td>
                            <td class="text-right">11,394</td>
                            <td class="text-right">30,562</td>
                            <td class="text-right">30,562</td>
                            <td class="text-right">94,309</td>
                        </tr>
                        <tr>
                            <td>أخرى</td>
                            <td class="text-right">2,515</td>
                            <td class="text-right">2,244</td>
                            <td class="text-right">3,411</td>
                            <td class="text-right">14,679</td>
                        </tr>
                        <tr>
                            <td>التزامات عقد إيجار</td>
                            <td class="text-right">49,673</td>
                            <td class="text-right">52,765</td>
                            <td class="text-right">61,752</td>
                            <td class="text-right">58,704</td>
                        </tr>
                        <tr>
                            <td>صافي الالتزامات المشتقة المسددة – مبادلات معدلات الفائدة</td>
                            <td class="text-right">4,588</td>
                            <td class="text-right">5,184</td>
                            <td class="text-right">6,911</td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td class="blueColor" colspan="5">كما في 31 ديسمبر 2019</td>
                        </tr>
                        <tr>
                            <td>قروض بنكية</td>
                            <td class="text-right">282,530</td>
                            <td class="text-right">219,772</td>
                            <td class="text-right">1,150,672</td>
                            <td class="text-right">22,855</td>
                        </tr>
                        <tr>
                            <td>ذمم تجارية دائنة وأخرى</td>
                            <td class="text-right">805,883</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                        </tr>
                        <tr>
                            <td colspan="5">مطلوبات غير متداولة أخرى</td>
                        </tr>
                        <tr>
                            <td>مستحق لوزارة المالية السعودية</td>
                            <td class="text-right">12,452</td>
                            <td class="text-right">77,188</td>
                            <td class="text-right">214,862</td>
                            <td class="text-right">31,953</td>
                        </tr>
                        <tr>
                            <td>مستحق لهيئة الاتصالات وتقنية المعلومات مقابل طيف ترددي</td>
                            <td class="text-right">9,637</td>
                            <td class="text-right">9,637</td>
                            <td class="text-right">28,912</td>
                            <td class="text-right">53,188</td>
                        </tr>
                        <tr>
                            <td>أخرى</td>
                            <td class="text-right">-</td>
                            <td class="text-right">4,312</td>
                            <td class="text-right">4,489</td>
                            <td class="text-right">16,239</td>
                        </tr>
                        <tr>
                            <td>التزامات عقد إيجار</td>
                            <td class="text-right">61,976</td>
                            <td class="text-right">66,185</td>
                            <td class="text-right">74,792</td>
                            <td class="text-right">75,694</td>
                        </tr>
                        <tr>
                            <td>صافي الالتزامات المشتقة المسددة – مبادلات معدلات الفائدة</td>
                            <td class="text-right">21,887</td>
                            <td class="text-right">19,218</td>
                            <td class="text-right">22,220</td>
                            <td class="text-right">-</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>